
















import { Component, Prop, Vue } from 'vue-property-decorator'
import __ from '@/shared/helpers/__'
import PageHeader from '@/admin/components/PageHeader.vue'
import Form from '@/shared/components/form/Form.vue'
import FormBase from '@/shared/classes/form/form-base'
import { GlobalActions } from '@/shared/store/global/global.actions'
import Field, { FieldSizes } from '@/shared/classes/form/field'
import { HttpMethod } from '@/shared/helpers/requests.helper'
import { getNodeApiUrlByVersion } from "@/config";
import HseRiskCategory from "@/shared/modules/hse-risk-categories/hse-risk-category.model";
import { validateFields } from "@/shared/helpers/validate";
import { SnackBarTypes } from "@/shared/helpers/snack-bar.helper";

@Component({
  components: { Form, PageHeader },
  methods: { __ },
})
export default class CreateRiskCategoriesDialog extends Vue {
  @Prop() meta!: any
  form: FormBase | null = null
  loading: boolean = false

  created() {
    let fields = [
      new Field()
        .setKey('name')
        .setSize(FieldSizes.full)
        .isRequired()
        .setTranslatable(true)
        .setTitle(__('admin.components.hse.risk-categories.create-dialog.form.name')),
    ]

    this.form = new FormBase()
      .setEndpoint(`${getNodeApiUrlByVersion()}/hse-risk-categories`)
      .setTranslatable(true)
      .setMethod(HttpMethod.POST)
      .setModel(HseRiskCategory)
      .setFields(fields)
      .setValidate(true, { onlyRegionLangRequired: true })
      .setShowDefaultValidationError(true)
      .setOnSuccess(this.meta.onSuccess)
  }

  async closeDialog() {
    await this.$store.dispatch(GlobalActions.closeDialog)
  }
}
